import React from 'react';
import './Aboutus.css'; 
import AboutImg from '../../Images/about-us1.png';
import EcosystemImg from '../../Images/about-us2.png';
import laptop from '../../Images/about-us3.png';
import Icon1 from '../../Images/Icon1.gif';
import Icon2 from '../../Images/Icon2.gif';
import Icon3 from '../../Images/Icon3.gif';
import Icon4 from '../../Images/Icon4.gif';
import {Helmet} from "react-helmet";
const AboutUs = () => {
  return (
    <div className="about-us-container">
        <Helmet>
                <meta charSet="utf-8" />
                <title>About Us - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
      {/* Section 1: Description and Image */}
      <div className="about-section">
        <div>
          <h1>
            <span className="red">Otter</span> <span className="blue">Tutors</span>
          </h1>
          <p>
            At Otter Tutors, we make quality education accessible to every student. Noticing the challenges of
            one-size-fits-all teaching in offline centers, we created an online platform offering personalized
            learning with interactive classes and 24/7 support.
          </p>
          <p>
            Serving 150+ students from K1 to K12 and preparing them for exams like <em>IIT JEE and NEET</em>, our
            mission is to empower students to excel academically and build confidence.
          </p>
          <p>Join Otter Tutors and transform learning into a journey of success and joy!</p>
        </div>
        <img src={AboutImg} alt="Otter Tutor" />
      </div>

      {/* Section 2: Here We Are */}
      <div className="here-we-are-section">
        <div>
          <h2>Here We Are</h2>
          <p>
            Otter Tutors houses multiple platforms such as the Otter Tutors Website, Otter Tutors Mobile App,
            Otter Tutors YouTube Channel, and our social media handles on Instagram and Facebook. These platforms
            ensure that students have seamless access to quality education, live classes, interactive quizzes,
            and doubt-solving support.
          </p>
        </div>
        <img src={laptop} alt="Here We Are" />
      </div>

      {/* Section 3: Holistic Learning Ecosystem */}
      <div className="holistic-learning-section">
        <img src={EcosystemImg} alt="Holistic Learning" className="ecosystem-image"/>
        <div>
          <h2>Holistic Learning Ecosystem</h2>
          <div className="grid-container">
            <div className="list-item">
              <img src={Icon1} alt="Primary" />
              <div>
                <h3>Primary</h3>
                <p>Foundational learning for K1-K5 with interactive methods.</p>
              </div>
            </div>
            <div className="list-item">
              <img src={Icon2} alt="Secondary" />
              <div>
                <h3>Secondary</h3>
                <p>Concept-focused education for Classes 6-8.</p>
              </div>
            </div>
            <div className="list-item">
              <img src={Icon3} alt="Senior Secondary" />
              <div>
                <h3>Senior Secondary</h3>
                <p>Advanced tutoring for Classes 9-12 and board exams.</p>
              </div>
            </div>
            <div className="list-item">
              <img src={Icon4} alt="Competitive Exams" />
              <div>
                <h3>Competitive Exams</h3>
                <p>Specialized coaching for IIT JEE, NEET, and more.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
